import React, { Dispatch, useEffect, useState } from "react";
import { Box, Radio, TextField, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getAudienceForSelectAction } from "../../ProjectSection/AudienceSection/Store/Audience.action";
import { commonStyles } from "../../../../assets/MUIStyles/commonStyles";
import Select from "react-select";

const CampaignForm = ({ obj }) => {
  const dispatch: Dispatch<any> = useDispatch();
  const { projectId } = useParams<{ projectId: string }>();
  const { formState, setFormState } = obj;
  const [audienceArray, setAudienceArray] = useState([]);
  const [msg, setMsg] = useState("");

  useEffect(() => {
    const init = async () => {
      const obj1 = {
        pageIndex: 1,
        pageSize: 100000,
      };
      const res: any = await dispatch(
        getAudienceForSelectAction(projectId, obj1)
      );

      setAudienceArray(res);
    };
    init();
  }, []);

  function hasFormValueChanged(e) {
    if (
      e.target.name === "name" &&
      /[^a-zA-Z0-9\&\ /]/.test(e.target.value.toString())
    ) {
      setMsg("Name can only contain alphanumeric characters, ampersand(&)");
      setTimeout(() => {
        setMsg("");
      }, 3000);
      return;
    }

    setFormState({
      ...formState,
      [e.target.name]: { value: e.target.value },
    });
  }

  return (
    <Box
      sx={{
        minHeight: 300,
      }}
    >
      <Box>
        <Box>
          <Typography className="font-14-grey">Name</Typography>
          <TextField
            name="name"
            value={formState.name.value}
            onChange={hasFormValueChanged}
            variant="outlined"
            fullWidth
            placeholder="Example it can be “Real Estate Campaign”"
            sx={commonStyles.inputField}
            slotProps={{
              htmlInput: { maxLength: 50 },
            }}
          />
        </Box>
      </Box>
      <Box
        sx={{
          mt: 2,
        }}
      >
        <Typography className="font-14-grey mb-2">Audience</Typography>
        <Select
          isMulti
          options={audienceArray?.map((item: any) => ({
            ...item,
            label: item?.audienceName,
            value: item?._id,
          }))}
          value={formState?.selectedAudiences?.map((item: any) => ({
            ...item,
            label: item?.audienceName,
            value: item?._id,
          }))}
          onChange={(selectedOptions) => {
            setFormState((prev) => ({
              ...prev,
              selectedAudiences: selectedOptions?.map(
                ({ label, value, ...rest }) => rest
              ),
            }));
          }}
          placeholder="Select Audiences"
          styles={commonStyles.customSelect}
          menuPortalTarget={document.body}
          menuPosition="fixed"
        />
      </Box>
      <Box
        sx={{
          mt: 2,
        }}
      >
        <Typography className="font-14-grey mb-2">Campaign Type :</Typography>
        <Box
          className="flex-row"
          sx={{
            gap: 1,
          }}
        >
          <Box
            className="flex-xy-center"
            sx={{
              gap: 0.5,
            }}
          >
            <Radio
              checked={!formState?.range}
              onChange={() => {
                setFormState((prev) => ({
                  ...prev,
                  range: false,
                }));
              }}
              sx={{
                "& .MuiSvgIcon-root": {
                  width: 16,
                  height: 16,
                },
              }}
            />
            <Typography
              className="font-14-grey"
              sx={{
                mb: 0,
              }}
            >
              Default
            </Typography>
          </Box>
          <Box
            className="flex-xy-center"
            sx={{
              gap: 1,
            }}
          >
            <Radio
              checked={formState?.range}
              onChange={() => {
                setFormState((prev) => ({
                  ...prev,
                  range: true,
                }));
              }}
              sx={{
                "& .MuiSvgIcon-root": {
                  width: 16,
                  height: 16,
                },
              }}
            />
            <Typography
              className="font-14-grey"
              sx={{
                mb: 0,
              }}
            >
              Range
            </Typography>
          </Box>
        </Box>
      </Box>
      <p style={{ color: "red" }}>{msg}</p>
    </Box>
  );
};

export default CampaignForm;
